const {reveal}=require('./transition.js');
document.querySelectorAll('[data-project-overview]').forEach(overview=>{
 const filters=[...overview.querySelectorAll('[data-project-filter]')];
 const items=[...overview.querySelectorAll('[data-project-category]')];
 const search=overview.querySelector('[data-project-search]');
 const normalize=text=>text.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss');
 const haystacks=items.map(item=>normalize(item.textContent));
 let category='all';
 const update=()=>{
  const query=normalize(search.value.trim());
  let count=0;
  items.forEach((item,index)=>{
   const visible=(category==='all'||item.dataset.projectCategory===category)&&haystacks[index].includes(query);
   item.classList.toggle('is-filtered-out',!visible);
   item.setAttribute('aria-hidden',String(!visible));
   if(visible){item.dataset.projectLayout=['wide','offset','offset','wide','full'][count%5];count++;}
  });
  overview.querySelector('[data-project-count]').textContent=`${count} ${count===1?'Projekt':'Projekte'}`;
  overview.querySelector('[data-project-empty]').hidden=count!==0;
 };
 filters.forEach(filter=>filter.addEventListener('click',()=>{
  category=filter.dataset.projectFilter;
  filters.forEach(button=>{const active=button===filter;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});
  update();reveal(overview.querySelector('.one-projects__grid'));
 }));
 search.addEventListener('input',update);
 const views=[...overview.querySelectorAll('[data-project-view]')];
 views.forEach(button=>button.addEventListener('click',()=>{
  overview.dataset.view=button.dataset.projectView;
  views.forEach(view=>view.setAttribute('aria-pressed',String(view===button)));
  reveal(overview.querySelector('.one-projects__grid'));
 }));
 // Search state stays in this page only; nothing is stored or sent to a service.
 update();
});
